<div class="app-empty-state" [ngClass]="['app-empty-state-' + size()]">
    <div class="app-empty-state__icon">
        <i [class]="icon()"></i>
    </div>
    <div class="app-empty-state__message">
        {{ message() }}
    </div>
    <div class="app-empty-state__action" *ngIf="showAction()">
        <button pButton pRipple type="button" class="btn btn-primary" [label]="actionLabel()" (click)="actionClick.emit()"></button>
    </div>
</div>
